'use strict';

import Items from '../../ui/Views/Announcements/ListItems';

export function getListItem (dealType, realtyType) {
  const section = dealType + '_' + realtyType;

  switch (section) {
    case 'rent_apartments': return Items.RentApartmentsListItem;
    case 'rent_commercials': return Items.RentCommercialsListItem;
    case 'rentDaily_apartments': return Items.RentDailyApartmentsListItem;

    case 'sale_apartments': return Items.SaleApartmentsListItem;
    case 'sale_commercials': return Items.SaleCommercialsListItem;
    case 'sale_garages': return Items.SaleGaragesListItem;
    case 'sale_lands': return Items.SaleLandsListItem;
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/classes/builder/mapListBuilder.js